var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Component, CustomElement, Event, html, Prop, nothing } from '@sick-davinci/ce-decorators';
import { IconRef } from '@sick-davinci/basic-elements';
import { style } from './NavigationItem.style';
import { icon_keyboard_arrow_right as submenuIndicatorIcon } from '@sick-davinci/material-icons/hardware/keyboard_arrow_right.icon';
/**
 * A `davinci-core-navigation-item` is an item of a `davinci-core-navigation`, which handles navigation
 *
 * @example
 * ```html
 *  <davinci-core-navigation-item route="/">home</davinci-core-navigation-item>
 *  <davinci-core-navigation-item route="/products" active>products</davinci-core-navigation-item>
 *  <davinci-core-navigation-item route="/settings/app" disabled>settings</davinci-core-navigation-item>
 *  <davinci-core-navigation-item route="/settings/user">user-settings</davinci-core-navigation-item>
 * ```
 */

export let NavigationItem = (_dec = Component({
  style: [style],
  tag: 'davinci-core-navigation-item',
  dependencies: [IconRef]
}), _dec2 = Prop({
  type: String
}), _dec3 = Reflect.metadata("design:type", Object), _dec4 = Prop({
  type: Boolean
}), _dec5 = Reflect.metadata("design:type", Boolean), _dec6 = Prop({
  type: Boolean
}), _dec7 = Reflect.metadata("design:type", Boolean), _dec8 = Prop({
  type: String
}), _dec9 = Reflect.metadata("design:type", String), _dec10 = Event('navigate'), _dec11 = Reflect.metadata("design:type", Object), _dec12 = Event('item-rendered'), _dec13 = Reflect.metadata("design:type", Object), _dec(_class = (_class2 = class NavigationItem extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "type", _descriptor, this);

    _initializerDefineProperty(this, "active", _descriptor2, this);

    _initializerDefineProperty(this, "disabled", _descriptor3, this);

    _initializerDefineProperty(this, "route", _descriptor4, this);

    this.initiallyRendered = false;

    _initializerDefineProperty(this, "navigateEvent", _descriptor5, this);

    _initializerDefineProperty(this, "itemRenderedEvent", _descriptor6, this);

    this.onClick = () => {
      if (!this.disabled) {
        this.navigateEvent.emit(this.route);
      }
    };
  }

  componentWillRender() {
    if (this.type === 'workflow' && this.parentElement.children.item(0) === this) {
      this.classList.add('first');
    } else {
      this.classList.remove('first');
    }
  }

  componentFirstRender() {
    // On slower clients the actual rendering may be to slow, so the Navigation's dimension-calculation fails.
    // Emitting after any size-change makes sure, the Navigation updates late enough, even on slow clients.
    this.resizeObserver = new ResizeObserver(_entries => {
      this.itemRenderedEvent.emit(null);
    });
    this.resizeObserver.observe(this);
  }

  componentDidRender() {
    this.initiallyRendered = true;

    this._runExternalRenderCallbacks();

    this.itemRenderedEvent.emit(null);
  }

  componentDisconnected() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  render() {
    return html`
      <span class="content-wrapper">
        ${this.renderChevron()}
        <span class="label" @click=${this.onClick}><slot @slotchange="${this._runExternalRenderCallbacks}"></slot></span>
      </span>
    `;
  }

  renderChevron() {
    if (this.type === 'workflow' && !this.classList.contains('first')) {
      return html`
        <davinci-icon-ref .src="${submenuIndicatorIcon}"></davinci-icon-ref>
      `;
    } else {
      return nothing;
    }
  }

  getWidthInfo() {
    if (!this.initiallyRendered) {
      return {
        content: 0,
        overall: 0,
        spacingLeft: 0,
        spacingRight: 0
      };
    }

    const computedStyle = window.getComputedStyle(this);

    const content = this._getElementWidth(this.shadowRoot.querySelector('.content-wrapper'));

    const spacingLeft = parseInt(computedStyle.paddingLeft, 10) + parseInt(computedStyle.marginLeft, 10);
    const spacingRight = parseInt(computedStyle.paddingRight, 10) + parseInt(computedStyle.marginRight, 10);
    const overall = content + spacingLeft + spacingRight;
    return {
      content,
      overall,
      spacingLeft,
      spacingRight
    };
  }

  _runExternalRenderCallbacks() {
    if (this.renderMenuItemCallback) {
      this.renderMenuItemCallback();
    }
  }

  _getElementWidth(element) {
    const computedStyle = window.getComputedStyle(element);
    return element.getBoundingClientRect().width + parseInt(computedStyle.marginLeft, 10) + parseInt(computedStyle.marginRight, 10);
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'basic';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "active", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "route", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "navigateEvent", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "itemRenderedEvent", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
